const setupShippingTooltip = (cartDrawer) => {
  const container = cartDrawer.querySelector('[data-cart-info-container]');

  if (container) {
    const trigger = container.querySelector('[data-cart-info-trigger]');
    const tooltip = container.querySelector('[data-cart-info-tooltip]');

    if (trigger && tooltip) {
      trigger.addEventListener('click', () => {
        tooltip.classList.toggle('is-visible');
      });
    }
  }
};

const observeCartDrawer = () => {
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  
  if (cartDrawer) {
    const config = { childList: true, subtree: true };
    
    const callback = (mutationsList, observer) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const container = cartDrawer.querySelector('[data-cart-info-container]');
          if (container) {
            setupShippingTooltip(cartDrawer);
            observer.disconnect();
            break;
          }
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(cartDrawer, config);
  }
};

document.addEventListener('DOMContentLoaded', observeCartDrawer);